var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"1rem 1.5rem"}},[_c('div',{attrs:{"slot":"top-right"},slot:"top-right"},[_c('button',{on:{"click":function($event){return _vm.$modal.hideAll()}}},[_vm._v(" ❌ ")])]),_c('h1',[_vm._v("This is created inline")]),_c('div',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }